var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTalentShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Award-Trophy-Star--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Award Trophy Star Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 5.5h-0.68A28.71 28.71 0 0 0 21.6 2a2 2 0 0 0 -0.55 -1.41 2 2 0 0 0 -1.4 -0.59H4.37A2 2 0 0 0 3 0.59 2 2 0 0 0 2.41 2a28.71 28.71 0 0 0 0.28 3.5H2a2 2 0 0 0 -2 2V10a5 5 0 0 0 3.27 4.69A1 1 0 0 0 4 12.81 3 3 0 0 1 2 10V7.5h1.07c1.37 5.53 5.39 7.67 8.79 7.67 5.61 0 8.22 -4.32 9.07 -7.67H22V10a3 3 0 0 1 -2 2.81 1 1 0 0 0 0.69 1.88A5 5 0 0 0 24 10V7.5a2 2 0 0 0 -2 -2ZM9.68 10.71a0.52 0.52 0 0 1 -0.74 -0.66L9.83 8a0.25 0.25 0 0 0 -0.05 -0.27L8.16 6.14a0.49 0.49 0 0 1 0.35 -0.86h1.84a0.24 0.24 0 0 0 0.22 -0.14l1 -2.07a0.53 0.53 0 0 1 0.94 0l1 2.07a0.24 0.24 0 0 0 0.23 0.14h1.84a0.49 0.49 0 0 1 0.34 0.86l-1.68 1.59a0.23 0.23 0 0 0 -0.06 0.27l0.9 2.05a0.53 0.53 0 0 1 -0.75 0.66l-2.2 -1.24a0.28 0.28 0 0 0 -0.25 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 16.67a11.69 11.69 0 0 1 -1.56 -0.11 0.24 0.24 0 0 0 -0.2 0.06 0.21 0.21 0 0 0 -0.08 0.19c0.09 3.36 -2.33 3.22 -2.51 3.24A2 2 0 0 0 7.7 24h8.61a2 2 0 0 0 0.19 -3.95c-1.52 -0.15 -2.66 -0.8 -2.57 -3.25a0.3 0.3 0 0 0 -0.08 -0.2 0.31 0.31 0 0 0 -0.21 -0.06 11.47 11.47 0 0 1 -1.78 0.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTalentShows);
export default ForwardRef;